module.exports = __webpack_public_path__ + "static/img/ylzz3.54a672e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/ylzz3.png
// module id = hBWR
// module chunks = 0